module.exports = __webpack_public_path__ + "static/img/day9.498120d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day9.jpg
// module id = la4S
// module chunks = 0